import React, { useEffect, useState } from 'react';
import { ttsAPI } from '../../services/api';
import './Admin.css';

const Settings = () => {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [ttsBetweenTracksEnabled, setTtsBetweenTracksEnabled] = useState(true);
  const [ttsSettingsLoading, setTtsSettingsLoading] = useState(true);
  const [ttsSettingsSaving, setTtsSettingsSaving] = useState(false);

  useEffect(() => {
    const fetchTtsSettings = async () => {
      try {
        const response = await ttsAPI.getSettings();
        setTtsBetweenTracksEnabled(response.data.ttsBetweenTracksEnabled !== false);
        setError('');
      } catch (err) {
        setError('Kon TTS-instellingen niet laden.');
      } finally {
        setTtsSettingsLoading(false);
      }
    };

    fetchTtsSettings();
  }, []);

  const getEmbedCode = () => {
    const streamUrl = `${window.location.origin}/stream.m3u8`;
    return `<video id="radio-player"></video>
<script src="https://cdn.jsdelivr.net/npm/hls.js@latest"></script>
<script>
if(Hls.isSupported()) {
  var video = document.getElementById('radio-player');
  var hls = new Hls();
  hls.loadSource('${streamUrl}');
  hls.attachMedia(video);
  hls.on(Hls.Events.MANIFEST_PARSED, function() {
    video.play();
  });
}
</script>`;
  };

  const getStreamUrl = () => {
    return `${window.location.origin}/stream.m3u8`;
  };

  const copyEmbedCode = () => {
    navigator.clipboard.writeText(getEmbedCode());
    setSuccess('Embed code gekopieerd naar klembord!');
    setTimeout(() => setSuccess(''), 3000);
  };

  const copyStreamUrl = () => {
    navigator.clipboard.writeText(getStreamUrl());
    setSuccess('Stream URL gekopieerd naar klembord!');
    setTimeout(() => setSuccess(''), 3000);
  };

  const handleToggleTtsBetweenTracks = async (event) => {
    const nextValue = event.target.checked;

    setTtsBetweenTracksEnabled(nextValue);
    setTtsSettingsSaving(true);
    setError('');

    try {
      await ttsAPI.updateSettings(nextValue);
      setSuccess(`TTS tussen nummers is nu ${nextValue ? 'ingeschakeld' : 'uitgeschakeld'}.`);
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setTtsBetweenTracksEnabled(!nextValue);
      setError(err.response?.data?.error || 'Opslaan van TTS-instellingen mislukt.');
    } finally {
      setTtsSettingsSaving(false);
    }
  };

  return (
    <div className="settings">
      <header className="page-header">
        <h1>Instellingen</h1>
        <p>Stream sharing en configuratie</p>
      </header>

      {success && <div className="message success"><i className="fas fa-check-circle"></i> {success}</div>}
      {error && <div className="message error"><i className="fas fa-exclamation-circle"></i> {error}</div>}

      <div className="settings-section">
        <h2><i className="fas fa-microphone"></i> TTS tussen nummers</h2>
        <p className="section-description">
          Zet dit uit als je geen gesproken berichten tussen tracks wilt laten afspelen.
        </p>

        <div className="share-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
          <div>
            <h3 style={{ marginBottom: '8px' }}>TTS-insertie</h3>
            <p className="help-text" style={{ margin: 0 }}>
              Geldt voor handmatige TTS-queue en automatisch gegenereerde DJ-aankondigingen.
            </p>
          </div>

          <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', fontWeight: 700 }}>
            <input
              type="checkbox"
              checked={ttsBetweenTracksEnabled}
              onChange={handleToggleTtsBetweenTracks}
              disabled={ttsSettingsLoading || ttsSettingsSaving}
            />
            {ttsSettingsLoading ? 'Laden...' : ttsBetweenTracksEnabled ? 'AAN' : 'UIT'}
          </label>
        </div>
      </div>

      <div className="settings-section">
        <h2><i className="fas fa-share-alt"></i> Stream Delen</h2>
        <p className="section-description">
          Deel deze links met luisteraars om de radio op andere websites te embedden.
        </p>

        <div className="share-card">
          <h3><i className="fas fa-link"></i> Stream URL</h3>
          <div className="url-display">
            <code>{getStreamUrl()}</code>
            <button onClick={copyStreamUrl} className="btn-copy">
              <i className="fas fa-copy"></i> Kopieer
            </button>
          </div>
          <p className="help-text">
            <i className="fas fa-info-circle"></i> Gebruik deze URL in audio players of streaming apps
          </p>
        </div>

        <div className="share-card">
          <h3><i className="fas fa-code"></i> Embed Code</h3>
          <div className="code-display">
            <pre><code>{getEmbedCode()}</code></pre>
          </div>
          <button onClick={copyEmbedCode} className="btn-copy">
            <i className="fas fa-copy"></i> Kopieer Embed Code
          </button>
          <p className="help-text">
            <i className="fas fa-info-circle"></i> Voeg deze code toe aan websites om de radio player te embedden
          </p>
        </div>
      </div>

      <div className="settings-section">
        <h2><i className="fas fa-info-circle"></i> Streaming Informatie</h2>
        
        <div className="info-grid">
          <div className="info-item">
            <i className="fas fa-server"></i>
            <div>
              <strong>Protocol</strong>
              <p>HLS (HTTP Live Streaming)</p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-music"></i>
            <div>
              <strong>Audio Codec</strong>
              <p>AAC 128kbps</p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-clock"></i>
            <div>
              <strong>Segment Lengte</strong>
              <p>2 seconden</p>
            </div>
          </div>

          <div className="info-item">
            <i className="fas fa-broadcast-tower"></i>
            <div>
              <strong>Status</strong>
              <p>24/7 Live Stream</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
